import { Form, Formik } from 'formik';
import ModalComponent from '../../components/modal/modal';
import ModalBodyComponent from '../../components/modal/modalBodyComponent';
import ModalFooterComponent from '../../components/modal/modalFooterComponent';
import { useWealthlaneIdentityApi } from '../../hooks';
import _ from 'lodash';
import CustomTextArea from '../../components/text-area/textArea';
import { ModalStatusType } from '../../types/common';
import InitialValuesForm from '../../constants/initialValues';
import { UPDATE_SIGNING_CERTIFICATE_VALIDATION } from '../../utils/validations/validations';
import { toast } from 'react-toastify';
import ToastComponent from '../../components/toast';
import usePostUpdateSigningCertificate from '../../hooks/post/usePostUpdateSigningCertificate';

interface SsoConfigurationModalProps {
  id: string;
  modalStatus: ModalStatusType;
  isModalOpen: boolean;
  closeModal: () => void;
}

interface SsoConfigType {
  providerSigningCertificate: string;
}

const UpdateSigningCertificateModal = ({
  id,
  modalStatus,
  isModalOpen,
  closeModal,
}: SsoConfigurationModalProps): JSX.Element => {
  const { handleRequest: handleRequestIdentity } = useWealthlaneIdentityApi();

  const { mutate: postUpdateSigningCertificate, isLoading: isLoadingPostUpdateSigningCertificate } =
    usePostUpdateSigningCertificate(handleRequestIdentity, () => {
      toast.success(<ToastComponent label='Success' message='Signing certificate edited.' />);
      closeModal();
    });

  const handleSubmit = (values: SsoConfigType): void => {
    postUpdateSigningCertificate({
      ssoConfigurationId: id,
      signingCertificate: values.providerSigningCertificate,
    });
  };

  return (
    <Formik
      enableReinitialize
      initialValues={InitialValuesForm.updateSigningCertificate}
      validationSchema={UPDATE_SIGNING_CERTIFICATE_VALIDATION}
      onSubmit={handleSubmit}>
      {({ errors, values, touched, handleChange, setFieldValue, initialValues }) => {
        return (
          <ModalComponent
            show={isModalOpen}
            closeModal={closeModal}
            loading={false}
            title={`Edit Signing Certificate`}
            valueEdited={_.isEqual(values, initialValues)}
            size='md'
            children={
              <Form>
                <ModalBodyComponent>
                  <CustomTextArea
                    label='Provider Signing Certificate'
                    name='providerSigningCertificate'
                    onChange={handleChange}
                    errors={errors}
                    touched={touched}
                    rows='15'
                    required
                    disabled={modalStatus === 'View'}
                  />
                </ModalBodyComponent>
                <ModalFooterComponent
                  modalStatus={'Add'}
                  onCloseModal={() => {
                    closeModal();
                  }}
                  valueChanged={_.isEqual(values, initialValues)}
                  loading={isLoadingPostUpdateSigningCertificate}
                  urlName='sso-configuration'
                />
              </Form>
            }
          />
        );
      }}
    </Formik>
  );
};

export default UpdateSigningCertificateModal;
